import 'react';

import GenericInputWrapper from './generic-wrapper/generic-input-wrapper';

const GenericCheckBoxInput = (
  {
    ref,
    ...props
  }
) => {
  return (
    <GenericInputWrapper {...props} ref={ref} as="input" type="checkbox" />
  );
};

GenericCheckBoxInput.displayName = 'GenericCheckBoxInput';

export default GenericCheckBoxInput;
